/* EcoFilter Ireland - water softener size calculator (/pages/water-softener-size-calculator), Oct 2026.
   Sizing rule (Colm, 26 Oct 2026): 1-4 people Mini, 5-6 Midi, 7+ Maxi. Three bathrooms takes a Mini up to
   the Midi and four or more bathrooms means the Maxi, so it keeps up when several showers run at once.
   Hardness decides whether a softener is worth having, not the size. The AquaSilk range is for mains water only:
   a private well gets a Clack system built to its water test report, never sold online, so no model or price is shown for wells.
   Same Eircode zone table as ef-hardness-2026.js and ef-softener-2026.js (keep all three in step).
   Prices and variants come from the products, printed into #szr-data by sections/ef-sizer-2026.liquid.
   No network calls. Nothing is stored. */
(function () {
  var root = document.getElementById('szr');
  if (!root) return;
  var data;
  try { data = JSON.parse(document.getElementById('szr-data').textContent); } catch (e) { return; }

  var ZONES = {
    "C15":{town:"Navan / Trim, Co. Meath",mgl:355},"A81":{town:"Carrickmacross, Co. Monaghan (borehole supply)",mgl:250,est:1},"A82":{town:"Kells, Co. Meath (Cavan towns on A82 are softer)",mgl:355},
    "H18":{town:"Monaghan town (borehole supply)",mgl:250,est:1},"A75":{town:"Castleblayney / Ballybay (Lough Egish supply)",mgl:100,est:1},"H12":{town:"Cavan town (Lough Acanon supply)",mgl:50,est:1},
    "A84":{town:"Ashbourne, Co. Meath",mgl:355},"A85":{town:"Dunshaughlin area, Co. Meath",mgl:355},"A86":{town:"Dunboyne, Co. Meath",mgl:355},
    "K32":{town:"Balbriggan (Bog of the Ring supply)",mgl:336},"K34":{town:"Skerries (Bog of the Ring supply)",mgl:336},"K56":{town:"Rush / Lusk (Bog of the Ring supply)",mgl:336},
    "K67":{town:"Swords (Leixlip supply)",mgl:200},"K36":{town:"Malahide (Leixlip supply)",mgl:200},"K78":{town:"Lucan (Leixlip supply)",mgl:200},"D15":{town:"Blanchardstown, Dublin 15 (Leixlip supply)",mgl:200},
    "D11":{town:"Finglas / North Dublin (Leixlip supply)",mgl:200},"W23":{town:"Maynooth / Celbridge / Leixlip (Leixlip supply)",mgl:200},
    "D02":{town:"Dublin 2 (Ballymore Eustace supply)",mgl:50},"D04":{town:"Dublin 4 (Ballymore Eustace supply)",mgl:50},"D06":{town:"Dublin 6 (Ballymore Eustace supply)",mgl:50},
    "D6W":{town:"Dublin 6W (Ballymore Eustace supply)",mgl:50},"D08":{town:"Dublin 8 (Ballymore Eustace supply)",mgl:50},"D14":{town:"Dublin 14 (Ballymore Eustace supply)",mgl:50},
    "D16":{town:"Dublin 16 (Ballymore Eustace supply)",mgl:50},"D18":{town:"Dublin 18 (Ballymore Eustace supply)",mgl:50},"D24":{town:"Tallaght, Dublin 24 (Ballymore Eustace supply)",mgl:50},
    "A94":{town:"Blackrock, Co. Dublin",mgl:50},"A96":{town:"Dún Laoghaire area",mgl:50},"A98":{town:"Bray, Co. Wicklow (Vartry supply)",mgl:50},
    "A63":{town:"Greystones, Co. Wicklow (Vartry supply)",mgl:50},"A67":{town:"Wicklow Town (Vartry supply)",mgl:50},
    "D10":{town:"Ballyfermot, Dublin (blended supply)",mgl:155},"D12":{town:"Crumlin, Dublin (blended supply)",mgl:155},"D20":{town:"Palmerstown, Dublin (blended supply)",mgl:155},"D22":{town:"Clondalkin, Dublin (blended supply)",mgl:155},
    "W91":{town:"Naas, Co. Kildare",mgl:325},"W12":{town:"Newbridge, Co. Kildare",mgl:325},"R14":{town:"Athy, Co. Kildare",mgl:325},
    "A92":{town:"Drogheda, Co. Louth",mgl:310},"A91":{town:"Dundalk, Co. Louth",mgl:310},"R32":{town:"Portlaoise, Co. Laois",mgl:300},"R35":{town:"Tullamore, Co. Offaly",mgl:300},
    "R93":{town:"Carlow town (Barrow supply)",mgl:300,est:1},"R95":{town:"Kilkenny city (Nore and limestone)",mgl:300,est:1},"N37":{town:"Athlone, Co. Westmeath (Lough Ree supply)",mgl:280,est:1},"N91":{town:"Mullingar, Co. Westmeath (Lough Owel supply)",mgl:280,est:1},
    "Y21":{town:"Wexford area",mgl:240},"Y35":{town:"Wexford town",mgl:240},"Y25":{town:"Gorey, Co. Wexford",mgl:240,est:1},
    "E41":{town:"Thurles, Co. Tipperary",mgl:235},"E91":{town:"Clonmel, Co. Tipperary (mixed supply)",mgl:235,est:1},"E45":{town:"Nenagh, Co. Tipperary",mgl:235,est:1},
    "X91":{town:"Waterford City",mgl:230},"X35":{town:"Dungarvan, Co. Waterford",mgl:230,est:1},
    "T12":{town:"Cork City",mgl:200},"T23":{town:"Cork City",mgl:200},"P51":{town:"Mallow, Co. Cork (Blackwater valley)",mgl:200,est:1},
    "V94":{town:"Limerick City",mgl:250},"V95":{town:"Ennis, Co. Clare (limestone springs)",mgl:300,est:1},"V14":{town:"Shannon, Co. Clare",mgl:250,est:1},
    "H91":{town:"Galway City (Lough Corrib supply)",mgl:135},"H54":{town:"Tuam, Co. Galway (limestone groundwater)",mgl:300,est:1},"H53":{town:"Ballinasloe, Co. Galway",mgl:300,est:1},"H62":{town:"Loughrea, Co. Galway",mgl:300,est:1},
    "V93":{town:"Killarney, Co. Kerry",mgl:130},"F91":{town:"Sligo Town (Lough Gill supply)",mgl:110},"F92":{town:"Letterkenny, Co. Donegal",mgl:75}
  };
  var PREFIX = {
    "D":{region:"North Dublin (Leixlip supply)",mgl:200},"A":{region:"North Leinster",mgl:320},"K":{region:"North Co. Dublin",mgl:200},"W":{region:"Co. Kildare",mgl:325},
    "C":{region:"Co. Meath",mgl:355},"R":{region:"Midlands (Laois / Offaly / Carlow / Kilkenny)",mgl:300},"N":{region:"Midlands (Westmeath / Longford)",mgl:280},
    "Y":{region:"Co. Wexford",mgl:240},"X":{region:"Co. Waterford",mgl:230},"E":{region:"Co. Tipperary",mgl:235},"T":{region:"Cork region",mgl:200},"P":{region:"Co. Cork",mgl:200},
    "V":{region:"Mid-West (Limerick / Clare)",mgl:250},"H":{region:"West / Border region",mgl:150},"F":{region:"North-West",mgl:100}
  };

  var state = { people: 4, baths: 2, supply: 'mains', key: null, zone: null, est: false };

  function band(m) {
    if (m < 100) return { label: 'Soft', color: '#2f9e6e' };
    if (m < 200) return { label: 'Moderately hard', color: '#d9a013' };
    if (m < 300) return { label: 'Hard', color: '#e07a1f' };
    return { label: 'Very hard', color: '#d2402e' };
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function eur(cents) { return '€' + Math.round(cents / 100).toLocaleString('en-IE'); }
  function routingKey(raw) {
    var v = String(raw || '').toUpperCase().replace(/\s+/g, '');
    if (v.length < 3) return null;
    var k = v.slice(0, 3);
    return /^[A-Z][0-9A-Z]{2}$/.test(k) ? k : null;
  }
  function findZone(k) {
    if (!k) return null;
    var z = ZONES[k];
    if (z) return { town: z.town, mgl: z.mgl, est: !!z.est };
    var p = PREFIX[k.charAt(0)];
    if (p) return { town: p.region, mgl: p.mgl, est: true };
    return null;
  }

  /* ---------- the sizing rule ---------- */
  function pick() {
    var p = state.people, b = state.baths;
    var model = p <= 4 ? 'mini' : (p <= 6 ? 'midi' : 'maxi');
    var step = '';
    if (b >= 4 && model !== 'maxi') { model = 'maxi'; step = 'four or more bathrooms'; }
    else if (b === 3 && model === 'mini') { model = 'midi'; step = 'three bathrooms'; }
    return { model: model, step: step };
  }
  var PEOPLE = ['', 'One person', 'Two people', 'Three people', 'Four people', 'Five people', 'Six people', 'Seven or more people'];
  var BATHS = ['', 'one bathroom', 'two bathrooms', 'three bathrooms', 'four or more bathrooms'];
  function why(pk) {
    var s = PEOPLE[Math.min(state.people, 7)] + ', ' + BATHS[Math.min(state.baths, 4)] + '.';
    if (pk.step) s += ' With ' + pk.step + ' we go up to the ' + (data[pk.model] ? data[pk.model].short : 'next size') + ', so it keeps up when several showers run at once.';
    return s;
  }

  /* ---------- output ---------- */
  var out = document.getElementById('szr-out');
  var hardLine = document.getElementById('szr-hard');
  var cards = document.querySelectorAll('.prod[data-model]');
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8.5 6 12.5 14 3.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function waterBox() {
    if (state.supply === 'well') {
      return '<div class="szr-water"><span>On a private well your Eircode can\'t tell us how hard the water is. A lab test can, and it shows what else needs treating first.</span></div>';
    }
    var z = state.zone;
    if (!z) return '<div class="szr-water szr-water--ask"><span>Add your Eircode to check your water is hard enough to need a softener.</span></div>';
    var b = band(z.mgl);
    var s = '<div class="szr-water"><em style="background:' + b.color + '">' + b.label + '</em><span><b>' + z.mgl + ' mg/L</b> in ' + esc(z.town) + '</span></div>';
    if (z.mgl < 200) s += '<p class="szr-note szr-note--mod">Moderately hard water builds scale slowly. A softener is worth it if you\'re already seeing scale on taps, shower screens and in the kettle.</p>';
    return s;
  }

  function render() {
    var pk = pick(), d = data[pk.model];
    var z = state.zone, well = state.supply === 'well';
    cards.forEach(function (el) { el.classList.toggle('rec', !well && el.getAttribute('data-model') === pk.model); });
    if (well) {
      out.innerHTML =
        '<p class="szr-k">On a private well</p>' +
        '<h2 class="szr-h">A softener built for your well</h2>' +
        '<p class="szr-why">The AquaSilk range is for mains water only. On a well we build a Clack system to suit your water test report, with any iron, manganese or bacteria treated ahead of the softener so they don\'t foul it.</p>' +
        '<div class="szr-water"><span>It\'s quoted from your report, so it isn\'t sold online. You pay on the day it\'s fitted, or by a secure payment link beforehand.</span></div>' +
        '<div class="szr-actions"><a class="btn btn--green" href="/pages/well-water-treatment">Send us your lab report</a>' +
        '<a class="btn btn--ghost" href="/pages/water-testing?supply=well#finder">No report yet? Order a well water test</a>' +
        '<a class="link" href="/blogs/news/water-softener-private-well">What to treat before the softener</a></div>' +
        '<ul class="szr-incl"><li>' + CHECK + '<span>Order your water test through us and the test fee comes off your install</span></li>' +
        '<li>' + CHECK + '<span>Our own plumbers, nationwide except Donegal, Kerry, Leitrim and Sligo</span></li></ul>';
      return;
    }
    if (!d) return;

    if (!well && z && z.mgl < 100) {
      out.innerHTML =
        '<p class="szr-k">Good news</p>' +
        '<h2 class="szr-h">You don\'t need a softener</h2>' +
        '<div class="szr-water"><em style="background:' + band(z.mgl).color + '">Soft</em><span><b>' + z.mgl + ' mg/L</b> in ' + esc(z.town) + '</span></div>' +
        '<p class="szr-why">Water this soft doesn\'t leave limescale, so a softener wouldn\'t earn its money. If it\'s the taste of your tap water that bothers you, an under-sink drinking water system is the right buy.</p>' +
        '<div class="szr-actions"><a class="btn btn--green" href="/pages/ecosoft-standard-pro">Drinking water systems</a></div>' +
        '<p class="szr-note">On a private well instead? Choose it above, as well water can be hard even where the mains is soft.</p>';
      return;
    }

    var html =
      '<p class="szr-k">The one for your house</p>' +
      '<div class="szr-model">' +
        (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.name) + ' water softener" width="240" height="180" loading="lazy">' : '') +
        '<div><h2 class="szr-h">' + esc(d.name) + '</h2><p>' + d.resin + ' litre resin</p></div>' +
      '</div>' +
      '<p class="szr-why">' + esc(why(pk)) + '</p>' +
      waterBox();

    html +=
      '<div class="szr-price"><div><span>Supply only</span><b>' + eur(d.supply) + '</b></div><div class="fit"><span>Supplied and fitted</span><b>' + eur(d.fitted) + '</b></div></div>' +
      '<div class="szr-actions">' +
        '<a class="btn btn--green" href="' + esc(d.url + '?variant=' + d.fitVariant) + '">Order the ' + esc(d.short) + ' fitted</a>' +
        '<a class="btn btn--ghost" href="' + esc(d.url + '?variant=' + d.supVariant) + '">Supply only, ' + eur(d.supply) + '</a>' +
      '</div>' +
      '<ul class="szr-incl"><li>' + CHECK + '<span>Fitted price includes the install, connection to your mains and drain, setting it for your water and the first fill of salt</span></li>' +
      '<li>' + CHECK + '<span>Our own plumbers, nationwide except Donegal, Kerry, Leitrim and Sligo</span></li></ul>';
    out.innerHTML = html;
  }

  /* ---------- questions ---------- */
  function press(group, attr, val) {
    group.querySelectorAll('[' + attr + ']').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute(attr) === String(val))); });
  }
  [['data-people', 'people', Number], ['data-baths', 'baths', Number], ['data-supply', 'supply', String]].forEach(function (q) {
    var g = root.querySelector('[' + q[0] + '-group]');
    if (!g) return;
    g.addEventListener('click', function (e) {
      var c = e.target.closest('[' + q[0] + ']'); if (!c) return;
      state[q[1]] = q[2](c.getAttribute(q[0]));
      press(g, q[0], state[q[1]]);
      render();
    });
    press(g, q[0], state[q[1]]);
  });

  /* ---------- Eircode ---------- */
  var form = document.getElementById('szr-eir-form');
  var input = document.getElementById('szr-eircode');
  var err = document.getElementById('szr-eir-err');
  function showHard() {
    if (!hardLine) return;
    var z = state.zone;
    if (!z) { hardLine.hidden = true; return; }
    hardLine.innerHTML = '<span>' + esc(z.town) + '</span><small>' + (z.est ? 'Regional estimate' : 'Uisce Éireann supply zone') + '</small>';
    hardLine.hidden = false;
  }
  function lookup(raw, quiet) {
    var k = routingKey(raw), z = findZone(k);
    if (!z) {
      if (!quiet) { err.hidden = false; input.focus(); }
      return false;
    }
    err.hidden = true;
    state.key = k; state.zone = z;
    showHard(); render();
    return true;
  }
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); lookup(input.value); });
    input.addEventListener('input', function () {
      err.hidden = true;
      var k = routingKey(input.value);
      if (k && k !== state.key) lookup(input.value, true);
      if (!k && state.zone) { state.key = null; state.zone = null; showHard(); render(); }
    });
    try {
      var q = new URLSearchParams(location.search).get('eircode');
      if (q && routingKey(q)) { input.value = q.toUpperCase(); lookup(q, true); }
    } catch (e) {}
  }

  render();
})();
